import { useState } from "react";
import api from "../api";
import { Link } from "react-router-dom";
import { resolveMediaUrl } from "../utils/url";

export default function UserSearch() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
  const qTrim = q.trim();
  if (qTrim.length === 0) {
    // Leere Suche: alle aktiven Nutzer
    const resp = await api.get("/users/list");
    const items = resp.data?.items || [];
    setResults(items);
    console.log("UserSearch Ergebnisse (leer):", items);
  } else if (qTrim.length === 1) {
    // Ein Zeichen: clientseitig filtern, um Nicht-Treffer auszublenden
    const resp = await api.get("/users/list");
    const all = resp.data?.items || [];
    const qLower = qTrim.toLowerCase();
    const items = all.filter(u =>
      (u.displayName || "").toLowerCase().includes(qLower) ||
      (u.username || "").toLowerCase().includes(qLower) ||
      (u.email || "").toLowerCase().includes(qLower)
    );
    setResults(items);
    console.log("UserSearch Ergebnisse (1 Zeichen):", items);
  } else {
    // Ab 2 Zeichen: serverseitige Suche
    const resp = await api.get("/users/search", { params: { q: qTrim } });
    const items = resp.data?.items || [];
    setResults(items);
    console.log("UserSearch Ergebnisse:", items);
  }
    } catch (e) {
      setError(e?.response?.data?.error || "Fehler bei der Suche");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ width: '100vw', margin: 0, padding: 0, position:'relative', left:'-120px' }}>
      <div style={{ maxWidth: 600, margin: '40px auto', padding: 24, background: '#222', borderRadius: 12, color: '#fff' }}>
        <h2 style={{ textAlign: 'center', marginBottom: 24 }}>Mitgliedersuche</h2>
        <form onSubmit={handleSearch} style={{ display: 'flex', gap: 12, marginBottom: 24 }}>
          <input
            type="text"
            value={q}
            onChange={e => setQ(e.target.value)}
            placeholder="Name oder E-Mail suchen..."
            style={{ flex: 1, padding: '10px 16px', borderRadius: 8, border: 'none', fontSize: '1.1em' }}
          />
          <button type="submit" style={{ background: '#32CD89', color: '#fff', padding: '10px 22px', borderRadius: 8, fontWeight: 600, border: 'none', boxShadow: '0 2px 8px #32CD8940', cursor: 'pointer' }}>
            {loading ? 'Suche...' : 'Suchen'}
          </button>
        </form>
        {error && <div style={{ color: '#c00', marginBottom: 16 }}>{error}</div>}
        {results.length > 0 ? (
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {results.map(u => (
              <li key={u.id} style={{ marginBottom: 18, background: '#333', borderRadius: 8, padding: '12px 18px', display: 'flex', alignItems: 'center', gap: 16 }}>
                <img src={resolveMediaUrl(u.avatarUrl || '/avatars/default-avatar.png')} alt="Avatar" style={{ width: 48, height: 48, borderRadius: '50%', objectFit: 'cover', border: '2px solid #32CD89' }} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: '1.1em' }}>{u.displayName || u.username}</div>
                  <div style={{ opacity: 0.7 }}>{u.username}</div>
                </div>
                <Link to={`/u/${u.id}`} style={{ background: '#32CD89', color: '#fff', padding: '8px 16px', borderRadius: 8, fontWeight: 500, textDecoration: 'none' }}>Profil ansehen</Link>
              </li>
            ))}
          </ul>
        ) : (
          <div style={{ color: '#888', textAlign: 'center', marginTop: 24 }}>Keine Ergebnisse gefunden.</div>
        )}
      </div>
    </div>
  );
}
